import { ApiError } from '@gorila-shared-ui/components';
import { PaginatedResponse } from '../types/app';
import { User, UserRequest } from '../types/users';
import { getRequest, postRequest } from './api';
import { URLS } from './urls/urls';

export const getUsers = async (
  page: number = 1,
  search: string = '',
  projection: string = 'full'
): Promise<{
  paginatedResponse?: PaginatedResponse<User>;
  error?: ApiError;
}> => {
  const response = await getRequest(URLS.users.all, {
    queryParams: { page, search, projection },
  });
  return {
    paginatedResponse: response?.data,
    error: response?.error,
  };
};

export const createUser = async (user: UserRequest): Promise<{ error?: ApiError }> => {
  const response = await postRequest(URLS.users.create, {
    body: {
      ...user,
      skills: user.skills.map((skill) => skill.slug),
      schedule: user.schedule.map((schedule) => ({
        ...schedule,
        startHour: schedule.startHour || null,
        endHour: schedule.endHour || null,
      })),
    },
  });
  return {
    error: response?.error,
  };
};

export const updateUser = async (userId: string, user: UserRequest): Promise<{ error?: ApiError }> => {
  const response = await postRequest(URLS.users.update(userId), {
    body: {
      ...user,
      skills: user.skills.map((skill) => skill.slug),
      schedule: user.schedule.map((schedule) => ({
        ...schedule,
        startHour: schedule.allDay ? null : schedule.startHour,
        endHour: schedule.allDay ? null : schedule.endHour,
      })),
    },
  });
  return {
    error: response?.error,
  };
};
